import { AnimatePresence, motion } from "framer-motion";
import { EyeOff, FlaskConical, Settings2 } from "lucide-react";
import { useHive } from "@/store/useHive";

/**
 * Persistent thin banner while sample data is visible — a user must never be
 * uncertain whether the numbers on screen are real. Sits directly under the
 * system bar, above windows.
 */
export function SampleDataBanner() {
  const sampleData = useHive((s) => s.sampleData);
  const setSampleVisibility = useHive((s) => s.setSampleVisibility);
  const openApp = useHive((s) => s.openApp);
  const active = !!sampleData?.present && !!sampleData.visible;

  return (
    <AnimatePresence>
      {active && (
        <motion.div
          initial={{ y: -28, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: -28, opacity: 0 }}
          className="absolute inset-x-0 top-[52px] z-[45] flex items-center justify-center gap-3 border-b border-amber-400/30 bg-amber-400/15 px-4 py-1 text-[11px] font-medium text-amber-600 backdrop-blur-sm dark:text-amber-300"
        >
          <span className="flex items-center gap-1.5">
            <FlaskConical size={12} /> You're viewing sample data — sample records are labelled and never leave Hive
          </span>
          <button
            onClick={() => void setSampleVisibility(false)}
            className="flex items-center gap-1 rounded px-1.5 py-0.5 font-semibold transition hover:bg-amber-400/20"
          >
            <EyeOff size={11} /> Hide
          </button>
          <button
            onClick={() => openApp("settings")}
            className="flex items-center gap-1 rounded px-1.5 py-0.5 font-semibold transition hover:bg-amber-400/20"
          >
            <Settings2 size={11} /> Manage
          </button>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
